// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".copyright[data-v-62c9ae66]{font-size:.875rem;line-height:1.8;color:hsla(0,0%,100%,.5)}.copyright-head[data-v-62c9ae66]{margin-bottom:.5625rem;font-size:.875rem;font-weight:400;color:hsla(0,0%,100%,.3)}.copyright-logo[data-v-62c9ae66]{display:inline-block;width:162px;font-weight:500;color:#fff}.copyright-logo img[data-v-62c9ae66]{width:100%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
